export const data = {
  leagues: [
    {
      id: 'ALL',
      label: 'All Leagues',
      value: 'ALL',
    },
    // Removing since this is now out of season
    {
      id: 'NFL',
      label: 'NFL',
      value: 'NFL',
    },
    {
      id: 'NCAAF',
      label: 'NCAAF',
      value: 'NCAAF',
    },
    {
      id: 'NBA',
      label: 'NBA',
      value: 'NBA',
    },
    {
      id: 'WNBA',
      label: 'WNBA',
      value: 'WNBA',
    },
    {
      id: 'MLB',
      label: 'MLB',
      value: 'MLB',
    },
    {
      id: 'NCAAB',
      label: 'NCAAB',
      value: 'NCAAB',
    },
    {
      id: 'NHL',
      label: 'NHL',
      value: 'NHL',
    },
    {
      id: 'UFC',
      label: 'UFC',
      value: 'UFC',
    },
    {
      id: 'EPL',
      label: 'EPL',
      value: 'EPL',
    },
    {
      id: 'TENNIS',
      label: 'Tennis',
      value: 'TENNIS',
    },
  ],
  parlayTypes: [
    {
      id: 'BEST',
      label: 'Show Best Parlay',
      value: 'best',
    },
    {
      id: 'CUSTOM',
      label: 'Custom',
      value: 'custom',
    },
  ],
  sportsbooks: [
    {
      id: 'BETMGM',
      label: 'BetMGM',
      value: 'BETMGM',
    },
    {
      id: 'DRAFTKINGS',
      label: 'DraftKings',
      value: 'DRAFTKINGS',
    },
    {
      id: 'FANDUEL',
      label: 'FanDuel',
      value: 'FANDUEL',
    },
  ],
};
